import { Box } from '@mui/material';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { useSettings } from 'src/@core/hooks/useSettings';
import { v4 as uuidv4 } from 'uuid';
import { DashboardObjectWidgetDto } from 'src/models/account';
import DashboardComponentOptionImage from './DashboardComponentOptionImage';

interface DraggableComponentWrapperProps {
  component: DashboardObjectWidgetDto;
}

const DashboardComponentOption = ({ component }: DraggableComponentWrapperProps) => {
  const { settings } = useSettings();
  // @ts-ignore
  const { id, componentName, description, image, minWidth, maxWidth, minHeight, maxHeight, isResizeable } = component;

  return (
    <Box
      sx={{
        width: '225px',
        height: '175px',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 12px -1px rgba(0,0,0,0.3)',
        borderRadius: '4px',
        padding: '2px',
        position: 'relative',
        '&:hover': {
          cursor: settings.unlockDashboardLayout ? 'grab' : 'not-allowed'
        },
        '&:hover > div.overlay': {
          opacity: '1'
        }
      }}
      className="droppable-element"
      draggable={settings.unlockDashboardLayout}
      unselectable="on"
      onDragStart={e => {
        e.dataTransfer.setData(
          'object',
          JSON.stringify({
            id: uuidv4(),
            type: componentName,
            title: description,
            dimensions: { w: minWidth, h: minHeight, minW: minWidth, minH: minHeight, maxW: maxWidth, maxH: maxHeight },
            isResizeable: isResizeable,
            dashboardWidgetId: id
          })
        );
      }}>
      <Box sx={{ height: '100%', backgroundColor: '#fff' }}>
        <DashboardComponentOptionImage image={image} componentName={componentName} description={description} />
      </Box>
      <Box
        className="overlay"
        sx={{
          borderRadius: '4px',
          opacity: '0',
          position: 'absolute',
          backgroundColor: 'rgba(0,0,0,0.6)',
          height: '100%',
          width: '100%',
          top: '0',
          left: '0',
          transition: 'opacity .2s ease-in',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center'
        }}>
        <VigoTypography
          disableTranslation
          value={description}
          sx={{ marginTop: '10px', fontWeight: 'bold', color: '#fff' }}
        />
      </Box>
    </Box>
  );
};

export default DashboardComponentOption;
